import { Logout } from "@mui/icons-material";
import {
  useGetDashboardProfileQuery,
  useGetDashboardProfilebyIdQuery,
} from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch } from "react-redux";
import { logOut } from "features/auth/authSlice";
import { useNavigate } from "react-router-dom";
const ProjectNavbar = () => {
  const navigate = useNavigate();
  const projectId = localStorage.getItem("projectId");

  //   const location = useLocation();
  //     const currentUser = useSelector(selectCurrentUser);
  //     const RoleAcessParams = currentUser?.realm_access?.roles;
  // const { id } = useParams();
  // const projectId=location?.state?.projectId
  // const noSidebar = location.state?.active && RoleAcessParams.includes("admin");

  // const noSidebar = location.pathname.includes("project") && /\/project\/dashboard\/[a-f0-9\-]{36}/.test(location.pathname) || RoleAcessParams.includes("admin");
  //  console.log("noSidebar",noSidebar,"----",location)
  const { data: userProfile } = useGetDashboardProfilebyIdQuery(
    // noSidebar?id: "",
    projectId ? projectId : "",
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const auth = useAuth();
  const dispatch = useDispatch();
  const handlelogOut = (e) => {
    e.preventDefault();
    localStorage.removeItem("authState");
    localStorage.removeItem("locationStore");
    localStorage.removeItem("districtName");
    localStorage.removeItem("locationList");
    localStorage.removeItem("locationDropdown");
    localStorage.removeItem("reduxState");
    localStorage.removeItem("projectId");

    dispatch(logOut());
    auth.removeUser();
    auth.signoutRedirect({ id_token_hint: auth.user.id_token });
  };
  return (
    <div style={{ background: "#fbfbfb" }}>
      <nav
        className="d-flex justify-content-between align-items-center border-bottom"
        style={{
          padding: "0.75rem 1.5rem",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        <img
          src="/assets/img/LC-logo.png"
          alt="LC Logo"
          style={{ height: "42px", cursor: "pointer", objectFit: "contain" }}
          onClick={() => navigate("/dashboard")}
        />

        <h3
          style={{
            fontWeight: 800,
            margin: 0,
            textAlign: "center",
            flex: 1,
            textTransform: "capitalize",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
          title={userProfile?.data?.organization_details?.project?.project_name}
        >
          {userProfile?.data?.organization_details?.project?.project_name}
        </h3>

        <div
          className="d-flex align-items-center gap-3"
          style={{ height: "50px", flexShrink: 0 }}
        >
          <img
            src={userProfile?.data?.organization_details?.project?.project_url}
            style={{
              maxHeight: "100%",
              maxWidth: "160px",
              objectFit: "contain",
            }}
            // alt="Project Logo"
          />
          <button
            className="btn bg-primary text-white px-2 py-2 d-flex justify-content-center align-items-center"
            onClick={handlelogOut}
            style={{ borderRadius: "6px", height: "36px", width: "36px" }}
          >
            <Logout style={{ fontSize: "18px" }} />
          </button>
        </div>
      </nav>
    </div>
  );
};

export default ProjectNavbar;
